import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';

@JsonObject('model.OrderStockInfo')
export class OrderStockInfo extends AbstractModel {

	@JsonProperty(Number, 'cvMaterialId')
  cvMaterialId: number;

  @JsonProperty(Number, 'projectId')
  projectId: number;

  @JsonProperty(Number, 'reserveQty')
  reserveQty: number;

	@JsonProperty(String, 'projectName')
  projectName?: string;

  @JsonProperty(String, 'projectNumber')
  projectNumber?: string;
}
